import { FC } from 'react';
import { NextgenImage, Button, ButtonStyles, ButtonWidth, LoaderType } from '@nextgen-web-framework/all';
import { CommonErrorScreenProps, FontSize, VerticalAlignment } from './types/propTypes';
import styles from './CommonErrorScreen.module.scss';

const CommonErrorScreen: FC<CommonErrorScreenProps> = ({
  title,
  description,
  buttonCTA,
  buttonText,
  imageSrc,
  fontSize = FontSize.LARGE,
  verticalAlignment = VerticalAlignment.CENTER,
}) => (
  <div
    className={`${styles['common-error-container']} ${styles[verticalAlignment]}`}
    data-testid="common-error-container-testid"
  >
    <div className={styles['container']}>
      {imageSrc && (
        <div className={styles['error-image']}>
          <NextgenImage src={`${imageSrc}`} isRelativeURL={true} loaderType={LoaderType.WEBFONTS} alt="Error" />
        </div>
      )}
      <div className={`${styles['error-text-container']} ${styles[fontSize]}`}>
        {title && <div className={styles['title']}>{title}</div>}
        {description && <div className={styles['desc']}>{description}</div>}
        {buttonCTA && buttonText && (
          <Button
            title={buttonText}
            buttonStyle={ButtonStyles.OUTLINE}
            buttonWidth={ButtonWidth.FULL_WIDTH}
            onClick={buttonCTA}
          />
        )}
      </div>
    </div>
  </div>
);

export default CommonErrorScreen;
